// extracted by mini-css-extract-plugin
export default {"Tabs":"AdminTabs_Tabs__l1+Et","Tab":"AdminTabs_Tab__WV5bQ","TabActive":"AdminTabs_TabActive__NC1e+"};